import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedCopyTranscriptButton.meta';

export type UseTrackClickedCopyTranscriptButtonParams = {
  clip_id: string;
  start_time_ms: number;
  end_time_ms: number;
};

export const useTrackClickedCopyTranscriptButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedCopyTranscriptButton = useCallback(
    (params: UseTrackClickedCopyTranscriptButtonParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedCopyTranscriptButton };
};
